import { render } from "./InfoSection.vue?vue&type=template&id=5a96dd56&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=5a96dd56&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a96dd56"]])

export default __exports__